<app-euds-loader [visible]="!isUserAuthenticated"></app-euds-loader>

<app-euds-opco-branding [opCo]="opCoForBranding">
  <div class="euds-window-view">
    <app-euds-smart-header-simple [showSignOutButton]="true" (clickSignOutEvent)="logout()" [textSignOut]="fullName"></app-euds-smart-header-simple>
    <div class="euds-page-view background-alt">
      <div class="nav-container">
        <div class="euds-container-full ssip-heading">
          <h1>Self Service Insights Portal</h1>
          <div class="select-opco-container">
            <app-euds-select label="OpCo"
                           class="select-opco"
                           [required]="true"
                           emptyOptionText="- Select -"
                           [(ngModel)]="opCoSelected"
                           (valueChange)="opCoValueSelected($event)">
              <app-euds-option slot="option" value="ACE">Atlantic City Electric</app-euds-option>
              <app-euds-option slot="option" value="BGE">BGE</app-euds-option>
              <app-euds-option slot="option" value="ComEd">ComEd</app-euds-option>
              <app-euds-option slot="option" value="DPL">Delmarva Power</app-euds-option>
              <app-euds-option slot="option" value="PECO">PECO</app-euds-option>
              <app-euds-option slot="option" value="PEPCO">Pepco</app-euds-option>
            </app-euds-select>
          </div>
        </div>
      </div>
      <app-euds-card elevation="sm" padding="sm" surface="white" display="block" additionalStyleClass="euds-container-full page-card" *ngIf="showMainContent">
        <app-euds-tab-nav ariaLabel="DSS Internal App Navigation"
                          [activeIndex]="selectedTabIndex"
                          [tabs]="tabs"
                          (tabChange)="tabChangeFunction($event)">
        </app-euds-tab-nav>
        <router-outlet></router-outlet>
      </app-euds-card>
      <!-- Default message when no OpCo is selected -->
      <app-euds-card
        elevation="sm"
        padding="sm"
        surface="white"
        display="block"
        additionalStyleClass="euds-container-full page-card"
        *ngIf="!showMainContent">
        <p class="ssip-default-message">Select an OpCo to proceed.</p>
      </app-euds-card>
    </div>
    <app-euds-smart-footer-simple></app-euds-smart-footer-simple>
  </div>
</app-euds-opco-branding>
